import type { IRequestClient, RequestConfig } from '../core/client'
import { API_ROUTES } from '../routes'
import type {
  DingTalkConfigResponse,
  DingTalkLoginRequest,
  DingTalkLoginResponse,
  DingTalkSyncResult,
} from '../../types/dingtalk'

/** 创建钉钉集成 API 客户端。 */
export function createDingTalkApi(client: IRequestClient) {
  return {
    getConfig: () =>
      client.get<DingTalkConfigResponse>(API_ROUTES.dingtalk.authConfig),
    login: (data: DingTalkLoginRequest) =>
      client.post<DingTalkLoginResponse>(API_ROUTES.dingtalk.authLogin, data),
    syncOrganization: (config?: RequestConfig) =>
      client.post<DingTalkSyncResult>(
        API_ROUTES.dingtalk.organizationSync,
        undefined,
        config,
      ),
  }
}

export type DingTalkApi = ReturnType<typeof createDingTalkApi>
